import { render, staticRenderFns } from "./DCompositeWorkspaceDropdown.vue?vue&type=template&id=640b9006&scoped=true&"
import script from "./DCompositeWorkspaceDropdown.vue?vue&type=script&lang=js&"
export * from "./DCompositeWorkspaceDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DCompositeWorkspaceDropdown.vue?vue&type=style&index=0&id=640b9006&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b9006",
  null
  
)

export default component.exports